let handler: ((payload: any) => any) | null = null;

export const setExtrasHandler = (d: (payload: any) => any) => (handler = d);

export const handleExtras = (payload: any) => handler && handler(payload);
